// This file was generated by figma/utils.mjs
export const ARCADE_CARDS_NAMES = {
  AMEX: 'Amex',
  APPLEPAY: 'Applepay',
  BANK: 'Bank',
  CASHAPP: 'Cashapp',
  CIRRUS: 'Cirrus',
  DINERSCLUB: 'Dinersclub',
  DISCOVER: 'Discover',
  JCB: 'Jcb',
  MAESTRO: 'Maestro',
  MASTERCARD: 'Mastercard',
  UNIONPAY: 'Unionpay',
  VISA: 'Visa',
} as const
